import React, { useState, useEffect } from "react";
import { Page, Image, Text, Document, View, Table, Cell, TableHeader, TableRow, TableBody } from "@react-pdf/renderer";
import { saveAs } from 'file-saver';
import { styles } from "./StylesPDFFactAportesMunicipales";
import { currencyFormat } from '../../js/Functions';
import logoAGM from "../../images/AGM Desarrollos Logo.png"



// IMGS





const PDFFactAportesMunicipales = ({ data }) => {
  let [currentDate, setCurrentDate] = useState('');
  const [color, setColor] = useState('');
  let [observation, setObservation] = useState('');

  const setInfo = () => {
    if (data.itemResultAporte) {
      const currentDate = new Date().toJSON().slice(0, 10)
      console.log(currentDate)
      setCurrentDate(currentDate)

      if (data.itemResultAporte.NO_CC_VENCIDAS > 0) {
        setColor('red')
      }
      let observation = ''
      switch (data.itemResultAporte.MUNICIPIO) {
        case 'MOMPOS':
        case 'ALTOS DEL ROSARIO':
        case 'BARRANCO DE LOBA':
        case 'CICUCO':
        case 'CLEMENCIA':
        case 'NUEVA GRANADA':
        case 'SAN ESTANISLAO':
        case 'SAN JACINTO':
        case 'SAN JUAN DEL CESAR':
        case 'SAN MARTIN DE LOBA':
        case 'SAN PEDRO':
        case 'TALAIGUA NUEVO':
        case 'URUMITA':
        case 'VILLANUEVA-BOLIVAR':
        case 'EL CARMEN DE BOLIVAR':
        case 'HATILLO DE LOBA':
        case 'SAN JUAN NEPOMUCENO':
        case 'TURBANA':
          observation = `FAVOR CONSIGNAR EN LA CUENTA DE AHORROS No. ${data.itemResultAporte.CUENTA_DESTINO} DE ${data.itemResultAporte.BANCO_DESTINO} A NOMBRE DE FONDO ABIERTO ACCIÓN UNO NIT: 800.193.848-8`;
          break;
        case 'SANTA ROSA':
          observation = `FAVOR CONSIGNAR EN LA CUENTA DE AHORROS No. ${data.itemResultAporte.CUENTA_DESTINO} DE ${data.itemResultAporte.BANCO_DESTINO}`;
          break;
        case 'MARGARITA':
          observation = `FAVOR CONSIGNAR EN LA CUENTA DE AHORROS No. ${data.itemResultAporte.CUENTA_DESTINO} DE  ${data.itemResultAporte.BANCO_DESTINO} A NOMBRE DE PATRIMONIOS AUTONOMOS ACCIÓN FIDUCIARIA FA 4845 ALUMBRADO PÚBLICO MARGARITA NIT: 805.012.921-0`
          break;
        default:
          break;
      }
      setObservation(observation);

    }
  }
  useEffect(() => {
    setInfo()

  })
  //console.log('data in pdf: ', data);


  return (

    data.itemResultAporte ?
      (
        <Document>
          <Page style={styles.body} size="A4" wrap>
            <View style={styles.view}>

              {/* header */}
              <View style={styles.row}>
                <View style={[{ width: "130px", }, styles.col_header]}>
                  <Image style={[{ width: 90, height: 90, }]} src={logoAGM} />
                </View>
                <View style={[{ width: "225px" }, styles.col_header]}>

                  <Text>AGM DESARROLLOS S.A.S.</Text>
                  <Text>NIT: 800186313-0</Text>
                  <Text>CENTRO, SECTOR MATUNA, AV. DANIEL</Text>
                  <Text>LEMAITRE, EDF. BANCO DEL ESTADO PISO 5</Text>
                  <Text>CARTAGENA - COLOMBIA</Text>
                </View>
                <View style={[{ borderRadius: '10px', border: "1px solid black", width: "150px", }, styles.col_header]}>
                  <Text >CUENTA DE COBRO</Text>
                  <Text style={[{ color: 'red', }]}>{data.itemResultAporte.CONSECUTIVO_FACT}</Text>
                </View>

              </View>
              {/* body  client info*/}

              <View style={styles.row}>
                <View style={[{ width: 354, borderRadius: '10px', border: "1px solid black", paddingTop: '3px', paddingLeft: '5px', marginRight: '1px' },]}>
                  <Text style={{ marginBottom: 5 }}>Cliente:           MUNICIPIO DE {data.itemResultAporte.MUNICIPIO}</Text>
                  <Text style={{ marginBottom: 5 }}>NIT:                {data.itemResultAporte.NIT_ALCALDIA}</Text>
                  <Text style={{ marginBottom: 5 }}>Dirección:       {data.itemResultAporte.DIRECCION_ALCALDIA}</Text>
                  <Text style={{ marginBottom: 5 }}>Ciudad:           {data.itemResultAporte.MUNICIPIO}</Text>
                  <Text style={{ marginBottom: 5 }}>Teléfono:         {data.itemResultAporte.TELEFONO_ALCALDIA}</Text>
                </View>
                <View style={[{ width: 150, borderRadius: '10px', border: "1px solid black", paddingTop: '3px', paddingLeft: '5px', justifyContent: 'center' },]}>
                  <Text style={{ marginBottom: 5 }}>Fecha:                    {data.itemResultAporte.FECHA_FACTURA}</Text>
                  <Text style={{ marginBottom: 5 }}>Forma de Pago:      MENSUAL</Text>
                  <Text style={{ marginBottom: 5 }}>Fecha de Vcto:        {data.itemResultAporte.FECHA_VENCIMIENTO}</Text>
                </View>

              </View>

              <View style={styles.table}>
                <View style={[styles.tableRow,]}>
                  <View style={[styles.tableCell, { width: 40, border: 0, borderBottom: 1, }]}>
                    <Text style={{ textAlign: 'center' }}>Ítem:</Text>
                  </View>
                  <View style={[styles.tableCell, { width: 370, borderBottom: 1, borderTop: 0 }]}>
                    <Text style={{ textAlign: 'center' }}>Descripción</Text>
                  </View>
                  <View style={[styles.tableCell, { width: 95, border: 0, borderBottom: 1 },]}>
                    <Text style={{ textAlign: 'center' }}>Valor Bruto</Text>
                  </View>
                </View>

                <View style={styles.tableRow}>
                  <View style={[styles.tableCell, { width: 40, border: 0, }]}>
                    <Text style={{ textAlign: 'center', marginTop: 20 }}>1</Text>
                  </View>
                  <View style={[styles.tableCell, { width: 370, borderBottom: 0, borderTop: 0 }]}>
                    <View>
                      <Text style={{}}>
                        {`${data.itemResultAporte.CONCEPTO_APORTE} CORRESPONDIENTE AL MES DE ${data.mesFactura} DEL AÑO ${data.anoFactura}`}
                      </Text>
                    </View>
                    <View style={[{ marginTop: 12, marginBottom: 5 }]}>
                      <Text style={{}}>
                        APORTE AL MUNICIPIO
                      </Text>
                    </View>

                    <Text style={{}}>
                      Total Valor Aporte
                    </Text>
                  </View>
                  <View style={[styles.tableCell, { width: 95, border: 0 }]}>
                    <Text style={{}}>{" "}</Text>
                    <Text style={{}}>{" "}</Text>
                    <Text style={{ textAlign: 'right', marginTop: 12, marginBottom: 5 }}>$ {currencyFormat(data.itemResultAporte.VALOR_FACTURA)}</Text>
                    <Text style={{ textAlign: 'right' }}>$ {currencyFormat(data.itemResultAporte.VALOR_FACTURA)}</Text>
                  </View>
                </View>
                <View style={[styles.tableRow,]}>
                  <View style={[styles.tableCell, { width: '100%', border: 0, borderTop: 1, }]}>
                  <Text style={[{ marginBottom: 10 }]}>VALOR EN LETRAS</Text>
                  {
                    data.valorEnLetras ? (<Text style={[{ marginBottom: 10 }]}>{data.valorEnLetras}</Text>): ''
                  }
                  </View>
                </View>
                <View style={[styles.tableRow,]}>
                  <View style={[styles.tableCell, { width: '100%', border: 0, borderTop: 1, }]}>
                    <Text style={[{ marginBottom: 10 }]}>CUENTAS COBRO VENCIDAS: <Text style={[{ color: `${color}` }]}>{currencyFormat(data.itemResultAporte.NO_CC_VENCIDAS)}</Text></Text>
                    {
                      data.itemResultAporte.FECHA_VENCIMIENTO > currentDate ?
                        (
                          <View>
                            <Text style={[{ marginBottom: 10 }]}>CARTERA CORRIENTE: <Text style={[{ color: `${color}` }]}>$ {currencyFormat(data.itemResultAporte.VALOR_FACTURA)}</Text></Text>
                            <Text style={[{ marginBottom: 10 }]}>CARTERA VENCIDA: <Text style={[{ color: `${color}` }]}>$ {currencyFormat(data.itemResultAporte.VALOR_CARTERA - data.itemResultAporte.VALOR_FACTURA)}</Text></Text>
                          </View>
                        ) :
                        (
                          <View>
                            <Text style={[{ marginBottom: 10 }]}>CARTERA CORRIENTE: <Text style={[{ color: `${color}` }]}>$ {currencyFormat(0)}</Text></Text>
                            <Text style={[{ marginBottom: 10 }]}>CARTERA VENCIDA: <Text style={[{ color: `${color}` }]}>$ {currencyFormat(data.itemResultAporte.VALOR_CARTERA)}</Text></Text>
                          </View>
                        )
                    }


                  </View>
                </View>
              </View>
              <View style={[styles.table, { borderRadius: '10px', marginTop: 3 }]}>
                <View style={[styles.tableRow, { marginTop: 1 }]}>
                  <View style={[styles.tableCell, { width: '100%', border: 0, }]}>
                    <Text style={[{ marginBottom: 10 }]}>Observaciones</Text>
                    <Text style={[{ marginBottom: 10 }]}>{observation}</Text>
                  </View>
                </View>
              </View>

              <View style={[styles.table, { marginTop: 10 }]}>
                <View style={[styles.tableRow, { marginTop: 1 }]}>
                  <View style={[styles.tableCell, { width: '100%', border: 0, }]}>
                    <Text style={[{ marginBottom: 10 }]}>El concepto cobrado en este documento corresponde a la obligación pactada, con ocasión al Contrato de Concesión celebrado
                      entre la entidad territorial y la empresa que emite la presente cuenta de cobro, correspondiente al aporte mensual que debe
                      realizar el Municipio para la financiación de la prestación del servicio de Alumbrado Público.
                    </Text>
                  </View>
                </View>
              </View>

              <View style={[styles.table, { border: 0, marginTop: 80 }]}>
                <View style={[styles.tableRow,]}>
                  <View style={[styles.tableCell, { width: 150, border: 0, borderBottom: 1, marginRight: 15 }]}>
                    <Text style={{ textAlign: 'center' }}>{data.itemResultAporte.USUARIO}</Text>
                  </View>
                  <View style={[styles.tableCell, { width: 170, border: 0, borderBottom: 1, }]}>
                    <Text style={{ textAlign: 'center', }}>PAOLA PALMIERI M</Text>
                  </View>
                  <View style={[styles.tableCell, { width: 150, border: 0, borderBottom: 1, marginLeft: 15 },]}>
                    <Text style={{ textAlign: 'center' }}>ARNOLD ÁLVAREZ</Text>
                  </View>
                </View>
                <View style={[styles.tableRow,]}>
                  <View style={[styles.tableCell, { width: 150, border: 0, marginRight: 15 }]}>
                    <Text style={{ textAlign: 'center' }}>Elaborado</Text>
                  </View>
                  <View style={[styles.tableCell, { width: 170, border: 0, }]}>
                    <Text style={{ textAlign: 'center' }}>Revisado</Text>
                  </View>
                  <View style={[styles.tableCell, { width: 150, border: 0, marginLeft: 15 }]}>
                    <Text style={{ textAlign: 'center' }}>Aprobación de Gerencia</Text>
                  </View>
                </View>
                <View style={[styles.tableRow, { marginTop: 20 }]}>
                  <View style={[styles.tableCell, { width: 150, border: 0, marginRight: 15 }]}>
                    <Text style={{ textAlign: 'center' }}></Text>
                  </View>
                  <View style={[styles.tableCell, { width: 170, border: 0, }]}>
                    <Text style={{ textAlign: 'center' }}>ORIGINAL</Text>
                  </View>
                  <View style={[styles.tableCell, { width: 150, border: 0, marginLeft: 15 }]}>
                    <Text style={{ textAlign: 'center' }}></Text>
                  </View>
                </View>
              </View>
            </View>

            <Text
              style={styles.pageNumber}
              render={({ pageNumber, totalPages }) =>
                `${pageNumber} / ${totalPages}`
              }
              fixed
            />
          </Page>
        </Document>
      )
      :
      ""


  );
};

export default PDFFactAportesMunicipales;
